module.exports = __webpack_public_path__ + "img/noReports.82b006d0.png";